export default __webpack_public_path__ + "static/media/Silk-Serif-Regular-Italic.5df37acf.otf";